export class Ticket {
    creation: string;
    drivingDirections: string;
    markingInstructions: string;
    excavator: Excavator;
    extent: string;
    isGridsCallerSupplied: boolean;
    number: string;
    ticketId: string;
    remarks: string;
    source: string;
    SuspendedCount: string;
    takenBy: string;
    ticketType: string;
    workCounty: string;
    workDoneFor: string;
    workIntersection: string;
    workOn: string;
    workPlace: string;
    workSite: WorkSite;
    workState: string;
    workStreetAddress: string;
    workStreetName: string;
    workStreetPrefix: string;
    workStreetSuffix: string;
    workStreetType: string;
    workType: string;
    ticketCodes: TicketCode[];

    natureOfWork: string;
    mapBook: string;
    ticketHistory: string;
    lonestarNumber: string;
    importDateTime: string;
    filename: string;
    lonestarSequence: string;
    importSource: string;
    interactionId: string;
    projectLength: string;
    excavationDepth: string;
    mechanizedEquipment: string;
    workZipCode: string;
    explosives: string;
    paint: string;
    directionalBoring: string;
    subdivision: string = "";
    jobNumber: string;
    deeperThan16: string;
    gps: string;
    gpsMethod: string;
    informationHeader: string;
    positiveResponse: string;
    serviceAreaExtent: string;
    queueCategory: string;
    qaTicketId: number;
    isCancellationRecall: boolean;
    isTicketNotes: boolean;
    ticketNotesCount: number;
    isCallerSuppliedWorkarea: boolean;
    packetId: number;

    shouldUpdateBy: string;
    goodUntil: string;

    isExplosives: boolean;
    isDirectionalBoring: boolean;
    isWhitePaint: boolean;
    isAddressInRemarks: boolean;

    depth: string;
    trsq: string;
    meetDateTime: string;
}

export class Excavator {
    address: string;
    callback: string;
    caller: string;
    callerEmail: string;
    callerPhone: string;
    callerPhoneExtension: string;
    city: string;
    contact: string;
    contactEmail: string;
    contactPhone: string;
    contactPhoneExtension: string;
    fax: string;
    name: string;
    phone: string;
    state: string;
    type: string;
    zip: number;
}

export class WorkSite {
    callerSuppliedPoints: boolean;
    latitude: number;
    longitude: number;
    secondaryLatitude: number;
    secondaryLongitude: number;
    viewAreaExtent: string;
    workArea: string;
    workAreaBuffer: string;
    workAreaExtent: string;
}

export class ItemAttributeValue {
    creation: string;
    id: number;
    itemAttribute: ItemAttribute;
    itemId: number;
    value: string;
}
export class ItemAttribute {
    creation: string;
    dataType: string;
    display: string;
    id: number;
    IsActive: boolean;
    isUpdatable: boolean;
    itemTypeId: number;
    name: string;
}

export class TicketCode {
    code: string;
    codeId: number;
    organizationName: string;
    isAdded: boolean;
    isSuppressed; boolean;
    isSystemSuppressed: boolean;
    organizationFacilities: string;
    organizationId: number;
}


export class TicketNotes {
    itemNote: ItemNote[];
}

export class ItemNote {
    subject: string;
    message: string;
    creation: string;
}

export class TicketHistory {
    GCOldTicketId: number;
    GCTicketId: number;
    GCTicketNumber: string;
    GCTakenBy: string;
    GCCreation: Date;
    TicketType: string;
}
